/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EHopeApprenantSearchType } from './EHopeApprenantSearchType';
import {
    EHopeApprenantSearchTypeFromJSON,
    EHopeApprenantSearchTypeFromJSONTyped,
    EHopeApprenantSearchTypeToJSON,
} from './EHopeApprenantSearchType';
import type { EListSearchType } from './EListSearchType';
import {
    EListSearchTypeFromJSON,
    EListSearchTypeFromJSONTyped,
    EListSearchTypeToJSON,
} from './EListSearchType';
import type { EListSearchTypeEHopeApprenantSearchTypeCombinableCriteria } from './EListSearchTypeEHopeApprenantSearchTypeCombinableCriteria';
import {
    EListSearchTypeEHopeApprenantSearchTypeCombinableCriteriaFromJSON,
    EListSearchTypeEHopeApprenantSearchTypeCombinableCriteriaFromJSONTyped,
    EListSearchTypeEHopeApprenantSearchTypeCombinableCriteriaToJSON,
} from './EListSearchTypeEHopeApprenantSearchTypeCombinableCriteria';

/**
 * 
 * @export
 * @interface EHopeApprenantSearchTypeListSearch
 */
export interface EHopeApprenantSearchTypeListSearch {
    /**
     * 
     * @type {Array<EListSearchTypeEHopeApprenantSearchTypeCombinableCriteria>}
     * @memberof EHopeApprenantSearchTypeListSearch
     */
    criterias?: Array<EListSearchTypeEHopeApprenantSearchTypeCombinableCriteria> | null;
    /**
     * 
     * @type {EListSearchType}
     * @memberof EHopeApprenantSearchTypeListSearch
     */
    searchMode?: EListSearchType;
    /**
     * 
     * @type {EHopeApprenantSearchType}
     * @memberof EHopeApprenantSearchTypeListSearch
     */
    value?: EHopeApprenantSearchType;
    /**
     * 
     * @type {EHopeApprenantSearchType}
     * @memberof EHopeApprenantSearchTypeListSearch
     */
    secondaryValue?: EHopeApprenantSearchType;
    /**
     * 
     * @type {Array<string>}
     * @memberof EHopeApprenantSearchTypeListSearch
     */
    readonly availableSearchTypes?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof EHopeApprenantSearchTypeListSearch
     */
    defaultSearchType?: string | null;
}

/**
 * Check if a given object implements the EHopeApprenantSearchTypeListSearch interface.
 */
export function instanceOfEHopeApprenantSearchTypeListSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EHopeApprenantSearchTypeListSearchFromJSON(json: any): EHopeApprenantSearchTypeListSearch {
    return EHopeApprenantSearchTypeListSearchFromJSONTyped(json, false);
}

export function EHopeApprenantSearchTypeListSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): EHopeApprenantSearchTypeListSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'criterias': !exists(json, 'criterias') ? undefined : (json['criterias'] === null ? null : (json['criterias'] as Array<any>).map(EListSearchTypeEHopeApprenantSearchTypeCombinableCriteriaFromJSON)),
        'searchMode': !exists(json, 'searchMode') ? undefined : EListSearchTypeFromJSON(json['searchMode']),
        'value': !exists(json, 'value') ? undefined : EHopeApprenantSearchTypeFromJSON(json['value']),
        'secondaryValue': !exists(json, 'secondaryValue') ? undefined : EHopeApprenantSearchTypeFromJSON(json['secondaryValue']),
        'availableSearchTypes': !exists(json, 'availableSearchTypes') ? undefined : json['availableSearchTypes'],
        'defaultSearchType': !exists(json, 'defaultSearchType') ? undefined : json['defaultSearchType'],
    };
}

export function EHopeApprenantSearchTypeListSearchToJSON(value?: EHopeApprenantSearchTypeListSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'criterias': value.criterias === undefined ? undefined : (value.criterias === null ? null : (value.criterias as Array<any>).map(EListSearchTypeEHopeApprenantSearchTypeCombinableCriteriaToJSON)),
        'searchMode': EListSearchTypeToJSON(value.searchMode),
        'value': EHopeApprenantSearchTypeToJSON(value.value),
        'secondaryValue': EHopeApprenantSearchTypeToJSON(value.secondaryValue),
        'defaultSearchType': value.defaultSearchType,
    };
}

